import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { RiArrowDownSLine } from "react-icons/ri";
import { TiTick } from "react-icons/ti";
import PropTypes from 'prop-types';
import Loader from "../../../utils/Loader";

const RestUserSettings = (props) => {
    const { refreshLogo } = props;
    const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    const token = localStorage.getItem("token");
    const userID = typeof window !== 'undefined' ? localStorage.getItem('loginUserId') || '' : '';
    const [userName, setUserName] = useState("")
    const [surName, setSurName] = useState("")
    const [email, setEmail] = useState("")
    const [selectedState, setSelectedState] = useState("");
    const [mobilePhone, setMobilePhone] = useState("")
    const [logo, setLogo] = useState(null)

    const [selecteLogo, setSelecteLogo] = useState(null)
    const [logoError, setLogoError] = useState('');
    const [profileSettingsData, setProfileSettingsData] = useState([]);
    const logoUrl = import.meta.env.VITE_BACKEND_APP_STORAGE_URL;
    const [isLoading, setIsLoading] = useState(false);
    const [showOption, setShowOption] = useState({ stato: false });
    const states = ["Active", "Inactive"];

    const toggleDropdown = (dropdownName) => {
        setShowOption({
            stato: dropdownName === "stato" ? !showOption.stato : false
        });
    };

    const handleStateSelect = (stato) => {
        setSelectedState(stato);
        setShowOption({ stato: false });
    };

    const getRestProfileData = useCallback(async () => {
        try {
            const responseProfileData = await axios.get(`${apiUrl}/api/v1/users/${userID}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setProfileSettingsData(responseProfileData.data);
        } catch (error) {
            console.error('Error fetching Profile Settings data:', error);
        }
    }, [apiUrl, userID, token]);

    const handleSave = async () => {
        if (!logoError) {
            const formData = new FormData();
            formData.append('user_id', userID);
            formData.append('name', userName);
            formData.append('status', selectedState);
            formData.append('surname', surName);
            formData.append('mobile_phone', mobilePhone);

            if (selecteLogo) {
                formData.append('avatar', selecteLogo);
            }

            try {
                setIsLoading(true)
                const response = await axios.post(`${apiUrl}/api/v1/user-profile`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${token}`,
                    },
                });
                const data = await response.data;
                refreshLogo();
                toast.success(data?.message, { theme: "colored", autoClose: 1000 });
                getRestProfileData();
                // navigate(`/restaurantPanel/dashboard/${localStorage.getItem("currentRestId") && localStorage.getItem("currentRestId")}`);
                // dropdown();
            } catch (error) {
                console.error('Error saving restaurant profile:', error);
                toast.error(error?.response?.data?.message, { theme: "colored", autoClose: 1000 });
            } finally {
                setIsLoading(false)
            }
        } else {
            toast.error(logoError, { theme: "colored", autoClose: 1000 })
        }
    };

    const handleLogoChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {

            const maxSizeInBytes = 2 * 1024 * 1024; // 2MB
            if (file.size > maxSizeInBytes) {
                setLogoError('Max size: 2MB. Please upload a smaller file.');
                return;
            }

            const img = new Image();
            img.onload = () => {
                setLogoError('');
                const fileUrl = URL.createObjectURL(file);
                setLogo(fileUrl);
                setSelecteLogo(file);
            };

            img.onerror = () => {
                setLogoError('Invalid image file. Please select a valid image.');
            };

            img.src = URL.createObjectURL(file);
        } else {
            setLogoError('No file selected. Please choose a file to upload.');
        }
    };

    useEffect(() => {
        getRestProfileData();
    }, [getRestProfileData]);

    useEffect(() => {
        if (profileSettingsData) {
            setUserName(profileSettingsData?.name);
            setSurName(profileSettingsData?.surname);
            setEmail(profileSettingsData?.email);
            setSelectedState(profileSettingsData?.status);
            setMobilePhone(profileSettingsData?.mobile_phone);
            const completeLogoUrl = profileSettingsData?.avatar
                ? `${logoUrl}/${profileSettingsData?.avatar}`
                : null;
            setLogo(completeLogoUrl);
        }
    }, [profileSettingsData, logoUrl]);

    return (
        <>
            <section className="border-t border-[#D9D9D9] md:mt-5 md:pt-10 pt-5">
                <h3 className="md:ext-2xl text-2xl font-bold mb-2 poppins-medium">Impostazioni del profilo</h3>
                <div className="w-full h-auto bg-[#FCFCFC] text-left text-red-700 space-y-5 border-[2px] border-[#8B24332B] sm:p-10 p-5 rounded-xl shadow-md font-sans">
                    <div className="flex flex-col space-y-4 mb-4 ">
                        <div className="flex md:flex-row flex-col gap-6 ">
                            <div className="flex flex-col md:w-[50%] w-full space-y-3 ">
                                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                    Nome :
                                </label>
                                <input
                                    type="text"
                                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                    value={userName || ""}
                                    onChange={(e) => setUserName(e.target.value)}
                                />
                            </div>
                            <div className="flex flex-col md:w-[50%] w-full space-y-3">
                                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                    Cognome :
                                </label>
                                <input
                                    type="text"
                                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                    value={surName || ""}
                                    onChange={(e) => setSurName(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="flex md:flex-row flex-col gap-6">
                            <div className="flex flex-col md:w-[50%] w-full space-y-3">
                                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                    Email :
                                </label>
                                <input
                                    type="text"
                                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                    value={email || ""}
                                    onChange={(e) => setEmail(e.target.value)}
                                    disabled
                                    style={{ cursor: "not-allowed" }}
                                />
                            </div>
                            <div className="flex flex-col md:w-[50%] w-full space-y-3">
                                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                    Cellulare :
                                </label>
                                <input
                                    type="number"
                                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                    value={mobilePhone || ""}
                                    onChange={(e) => setMobilePhone(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="flex md:flex-row flex-col gap-6">
                            <div className="flex flex-col md:w-[50%] w-full gap-3">
                                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                    Stato:
                                </label>
                                <div className="relative group w-auto bg-[#FFFFFF] dropdown-container">
                                    <div className="border border-gray-300 rounded-3xl">
                                        <button
                                            className="inline-flex justify-between items-center w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent focus:outline-none relative z-10"
                                            onClick={() => toggleDropdown("stato")}
                                        >
                                            <span className="mr-2 flex items-center gap-3 poppins-medium">
                                                {selectedState === "Active" ? "Attivo" : selectedState === "Inactive" ? "Inattivo" : "Scegli Stato"}
                                            </span>
                                            <RiArrowDownSLine />
                                        </button>
                                        <div
                                            className={`${showOption.stato ? "max-h-60 opacity-100 relative" : "max-h-0 opacity-0 overflow-hidden"
                                                } bg-[#FFFFFF] absolute top-0  p-2 px-4 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full  transition-all duration-300 ease-in-out`}
                                        >
                                            {states
                                                .filter((states) => states !== selectedState)
                                                .map((states, index, array) => (
                                                    <label
                                                        key={states}
                                                        className={`${index !== array.length - 1 ? "border-b border-[#8b24331f]" : ""} px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn`}
                                                        onClick={() => handleStateSelect(states)}
                                                    >
                                                        <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                                            {states === "Active" ? "Attivo" : states === "Inactive" ? "Inattivo" : ""}
                                                        </span>
                                                    </label>
                                                ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col md:w-[50%] w-full space-y-3">
                                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                    Avatar:
                                </label>
                                <div className="text-xs text-[#8B8B8B] poppins-regular">
                                    Recommended ratio: 800 x 600 px | Max size: 2MB
                                </div>
                                <div className="file-input poppins-regular px-4 py-3 text-[12px] text-[#8B8B8B] rounded-[50px] bg-transparent border border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb]">
                                    <input type="file" onChange={handleLogoChange} accept="image/*" />
                                    <span className="button">Choose</span>
                                    <span className="label" data-js-label>No file selected</span>
                                </div>
                                {logoError && (
                                    <div className="text-xs text-red-500 mt-1">
                                        {logoError}
                                    </div>
                                )}
                                {logo && !logoError && (
                                    <div className="overflow-hidden mt-[10px] cursor-pointer h-full w-[100px] flex items-center justify-center">
                                        <img
                                            src={logo}
                                            alt="Preview"
                                            className="w-full object-cover rounded-lg shadow-md"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="flex text-sm sm:flex-row flex-col justify-start gap-4 mt-10">
                        {isLoading ? (
                            <button disabled type="button"
                                className="sm:w-[120px] w-full poppins-regular justify-center flex items-center space-x-2 p-1 px-3 bg-[#8A2533] text-white border-[1.5px] border-[#d18d97] rounded-lg transition-colors group">
                                <Loader />
                                Loading...
                            </button>
                        ) : (
                            <button className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                                onClick={handleSave}
                            >
                                <TiTick size={"25px"} color="green" />
                                <span className="poppins-regular">Aggiorna</span>
                            </button>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

RestUserSettings.propTypes = {
    refreshLogo: PropTypes.func.isRequired,
};

export default RestUserSettings;